module.exports = __webpack_public_path__ + "static/media/us.03f4ea44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/us.png
// module id = 2011
// module chunks = 0